@if (!refreshing) {
  <div id="consultNoteDetailPage">
    <app-consult-note-title [patientAttachment]="patientAttachment" />
    <app-consult-note-header [patientAttachment]="patientAttachment" />
  </div>
  <div class="m-2">Verified captures: {{ this.paging.count }}</div>
  <table class="table table-bordered table-hover">
    <thead class="table-dark">
      <tr>
        <th>CLAIM-ID</th>
        <th>STATUS</th>
        <th>ORIGINAL VERIFIED AT</th>
        <th>WRITTEN DATE</th>
        <th>SERVICE DATE</th>
        <th>SOURCE</th>
        <th>MRN</th>
        <th>RX-PATIENT</th>
        <th>RX-DOB</th>
        <th>RX-PRESCRIBER-NAME</th>
        <th>VALUE</th>
        <th>RX-DRUG</th>
      </tr>
    </thead>
    <tbody>
      @for (capture of verifiedCaptures; track capture) {
        <tr>
          <td>
            <a routerLink="/capture-admin/captures/{{capture.id}}" target="_blank">
              {{ capture.candidate.claimIdentifier }}
            </a>
            <div>
              <app-user-presence category="capture" [targetId]="capture.id" />
            </div>
          </td>
          <td class="status-column">
            <strong>{{ capture.status | captureStatus }}</strong>
            <br />
            {{ capture.statusReason | captureStatusReason }}
          </td>
          <td>{{ capture.originalVerifiedAt | date: 'MM/dd/yyyy' }}</td>
          <td>{{ capture.candidate.writtenDate | date: 'MM/dd/yyyy' }}</td>
          <td>{{ capture.candidate.serviceDate | date: 'MM/dd/yyyy' }}</td>
          <td>{{ capture.candidate.source }}</td>
          <td>{{ capture.patient.mrn }}</td>
          <td>{{ capture.candidate.patientFullName }}</td>
          <td>{{ capture.patient.dob }}</td>
          <td>
            <app-prescriber-name [provider]="capture.provider" [linkToProvider]="true" />
          </td>
          <td>
            {{ capture.estimatedValueForDisplay }}
            <app-high-value-indicator [capture]="capture" />
          </td>
          <td>
            <app-candidate-drug [candidate]="capture.candidate" />
            <div class="small"><strong>SOURCE:</strong> {{ capture.candidate.source }}</div>
          </td>
        </tr>
      }
    </tbody>
  </table>
  <app-pagination [paging]="this.paging" (pageChange)="onPageChange($event)" />
} @else {
  <mat-spinner />
}
